import { render, staticRenderFns } from "./WorkforceCenter.vue?vue&type=template&id=4f180585"
import script from "./WorkforceCenter.vue?vue&type=script&lang=js"
export * from "./WorkforceCenter.vue?vue&type=script&lang=js"
import style0 from "./WorkforceCenter.vue?vue&type=style&index=0&id=4f180585&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports